import { GetterTree } from 'vuex'
import { AssignmentStateInterface } from 'src/store/assessment/state'
import { StoreInterface } from 'src/store'

const getters: GetterTree<AssignmentStateInterface, StoreInterface> = {
  getAssignments: (state: AssignmentStateInterface): any => state.assignments,
  getStudentResponses: (state: AssignmentStateInterface): any => state.studentResponses,
  getScores: (state: AssignmentStateInterface): any => state.scores,
  getAnswerAttachments: (state: AssignmentStateInterface): any => state.answerAttachments,
  getUnansweredAssignmentsCount: (state: AssignmentStateInterface): any => state.unansweredAssignmentsCount
}

export default getters
